// ReSharper disable once InconsistentNaming
(function(window) {
    "use strict";

    window.bindGaq = function ($document) {

        $document.find('[data-gaq]').each(function () {
            var $element = $(this);
            var mouseWheelButton = 1;

            $element.bind('click', gaTrackEvent);

            // auxclick is experimental technology, but it is the only way to detect the mouse wheel button
            $element.bind('auxclick',
                function (e) {
                    if (e.button === mouseWheelButton) {
                        gaTrackEvent.apply(this, arguments);
                    }
                });
        });

        function gaTrackEvent() {
            var data = $(this).data('gaq').split('|');
            var cat = data[0];
            var act = data[1];
            var lab = data[2];
            window.siteEvent(cat, act, lab);
        }

    }

    bindGaq($(document));

})(window);